import React, { useEffect, useState } from 'react'
import { Modal, Button, Form } from 'react-bootstrap'
import AsyncSelect from 'react-select/async'
import { getAzureGroups, getAzureUsers } from '../../utils/requestHelper'
import { useTranslation } from 'react-i18next'

const SelectDirectoryObjectModal = (props) => {
  const { t } = useTranslation()
  const [type, setType] = useState('user')
  const [selected, setSelected] = useState(null)

  useEffect(() => {
    if (props.modalOpen) {
      setType('user')
      setSelected(null)
    }
  }, [props.modalOpen])

  const handleTypeChange = (nextType) => {
    setType(nextType)
    setSelected(null)
  }

  const loadOptions = async (input) => {
    const search = input ? encodeURIComponent(input) : ''
    const options = type === 'user'
      ? await getAzureUsers(search ? `OR(displayName:${search})&search=OR(mail:${search})` : '')
      : await getAzureGroups(search ? `&search=OR(displayName:${search})&search=OR(description:${search})` : '')
    return options || []
  }

  if (!props.modalOpen) return null

  return (
    <Modal show={props.modalOpen} onHide={() => props.onModalClose(false)} backdrop="static" keyboard={false} size="md" centered>
      <Modal.Header closeButton>
        <Modal.Title>{t('selectDirectoryObject-modal-headline')}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Label>{t('input-label-objectType')}</Form.Label>
        <Form.Check
          type="switch"
          id={`directory-object-type-${props.controlId}`}
          className="mb-3"
          label={t(`directory-object-${type}`)}
          checked={type === 'group'}
          onChange={(event) => handleTypeChange(event.target.checked ? 'group' : 'user')}
        />
        <Form.Label htmlFor={`directory-object-${props.controlId}`}>{t(type === 'user' ? 'input-label-users' : 'input-label-groups')}</Form.Label>
        <AsyncSelect
          key={type}
          inputId={`directory-object-${props.controlId}`}
          defaultOptions
          cacheOptions
          loadOptions={loadOptions}
          value={selected}
          onChange={setSelected}
          getOptionValue={option => option.id}
          getOptionLabel={option => type === 'user' && option.mail ? `${option.displayName} (${option.mail})` : option.displayName}
          isOptionDisabled={option => (props.existingEntries || []).some(entry => entry.id === option.id)}
          placeholder={t(type === 'user' ? 'placeholder-label-users' : 'placeholder-label-groups')}
          noOptionsMessage={() => t('selectDirectoryObject-no-options')}
          loadingMessage={() => t('selectDirectoryObject-loading')}
        />
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={() => props.onModalClose(false)}>{t('button-close')}</Button>
        <Button variant="primary" disabled={!selected} onClick={() => props.onModalSave({ id: selected.id, displayName: selected.displayName, type, controlId: props.controlId })}>{t('button-save')}</Button>
      </Modal.Footer>
    </Modal>
  )
}

export default SelectDirectoryObjectModal